
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { getCMSContent } from '../services/firestoreService';

interface CMSPageProps {
    slug?: string; // Optional if using param
    title?: string; // Override title
}

export const CMSPage: React.FC<CMSPageProps> = ({ slug: propSlug, title: propTitle }) => {
    const { slug: paramSlug } = useParams();
    const navigate = useNavigate();
    const activeSlug = propSlug || paramSlug;

    const [content, setContent] = useState<{ title: string; content: string } | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchContent = async () => {
            setLoading(true);
            const pages = await getCMSContent();
            const page = pages.find((p: any) => p.slug === activeSlug);
            setContent(page || { title: 'Not Found', content: 'Page not found.' });
            setLoading(false);
        };
        fetchContent();
    }, [activeSlug]);

    if (loading) return <div className="flex justify-center items-center h-screen"><Loader2 className="animate-spin text-blue-600" /></div>;

    return (
        <div className="h-full bg-slate-50 flex flex-col animate-fadeIn">
            <div className="p-4 border-b border-slate-200 flex items-center gap-3 sticky top-0 bg-white z-10">
                <button onClick={() => navigate(-1)} className="p-2 hover:bg-slate-100 rounded-full">
                    <ArrowLeft className="w-5 h-5 text-slate-700" />
                </button>
                <h1 className="text-lg font-black text-slate-900">{propTitle || content?.title}</h1>
            </div>
            <div className="flex-1 overflow-y-auto p-8 space-y-8 scrollbar-hide">
                <div className="prose prose-slate max-w-none">
                    <p className="text-slate-700 font-medium leading-relaxed whitespace-pre-wrap">{content?.content}</p>
                </div>
            </div>
        </div>
    );
};
